import React from 'react';
import {Row, Col, Box, Button} from 'adminlte-2-react';
import {DateRangeInput} from '../ui/DateRangeInput';
import {Alert, alertTypes} from '../ui/alert';
import {Content} from '../ui/Content';
import {UsuarioSelect} from './UsuarioSelect';
import {EquipoSelect} from './EquipoSelect';
import {CheckBox} from '../ui/Checkbox';

export const ProduccionFiltroView = ({
  token,
  history,
  topAlert,
  usuariosLoadStatus,
  usuarioOption,
  setUsuarioOption,
  equipoOption,
  setEquipoOption,
  inicio,
  setInicio,
  fin,
  setFin,
  submit,
  setTopAlert,
  showUsuarios,
  setShowUsuarios,
  showEquipos,
  setShowEquipos,
  showSinFiltro,
  setShowSinFiltro,
}) => {
  let disableFiltro = false;

  if (!inicio || !fin) {
    disableFiltro = true;
  }

  if (
    (showUsuarios && !usuarioOption?.value) ||
    (showEquipos && !equipoOption?.value)
  ) {
    disableFiltro = true;
  }

  return (
    <Content title="Reporte de producción" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Row>
        <Col xs="12" md="10" mdOffset="1">
          <Box>
            <div style={{display: 'flex', justifyContent: 'flex-start'}}>
              <div
                style={{fontWeight: 'bold', marginRight: 30, marginBottom: 20}}>
                Filtrar por:
              </div>
              <div style={{marginRight: 30}}>
                <CheckBox
                  text="Todos"
                  checked={showSinFiltro}
                  onChange={checked => {
                    setEquipoOption(null);
                    setShowSinFiltro(checked);
                    if (checked) {
                      setShowUsuarios(false);
                      setShowEquipos(false);
                    }
                  }}
                />
              </div>
              <div style={{marginRight: 30}}>
                <CheckBox
                  text="Usuarios"
                  checked={showUsuarios}
                  onChange={checked => {
                    setEquipoOption(null);
                    setShowUsuarios(checked);
                    if (checked) {
                      setShowSinFiltro(false);
                      setShowEquipos(false);
                    }
                  }}
                />
              </div>
              <div>
                <CheckBox
                  text="Equipos"
                  checked={showEquipos}
                  onChange={checked => {
                    setUsuarioOption(null);
                    setShowEquipos(checked);
                    if (checked) {
                      setShowSinFiltro(false);
                      setShowUsuarios(false);
                    }
                  }}
                />
              </div>
            </div>
            {showUsuarios && (
              <UsuarioSelect
                token={token}
                usuarioOption={usuarioOption}
                setUsuarioOption={setUsuarioOption}
                onError={errorMsg =>
                  setTopAlert({
                    text: errorMsg,
                    type: alertTypes.danger,
                    closable: false,
                  })
                }
              />
            )}
            {showEquipos && (
              <EquipoSelect
                token={token}
                equipoOption={equipoOption}
                setEquipoOption={setEquipoOption}
                onError={errorMsg =>
                  setTopAlert({
                    text: errorMsg,
                    type: alertTypes.danger,
                    closable: false,
                  })
                }
              />
            )}
            <hr />
            <div className="form-group">
              <label>Fecha</label>

              <DateRangeInput
                showLabels
                labelStyle={{fontWeight: 'normal'}}
                inicio={inicio}
                setInicio={setInicio}
                fin={fin}
                setFin={setFin}
                xs={12}
                md={12}
              />
            </div>
            <div style={{float: 'right'}}>
              <div style={{display: 'inline-block', marginRight: 10}}>
                <Button
                  type="primary"
                  text="Filtrar"
                  onClick={submit}
                  disabled={disableFiltro}
                />
              </div>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
